import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as moment from 'moment';
import { parseTwoDecimals } from '../../../utils';


export const generateStudentPDF = (user, parents, data) => {
  const doc = new jsPDF({
    orientation: 'landscape',
  });

  doc.text(`Año escolar: ${data.school_year}`, 14, 10);
  doc.text(`Lapso: ${data.school_lapse}`, 14, 20);


  const userData = user.map((item) => [
    item?.fullname,
    item?.email,
    item?.document_type?.name + item?.document,
    data?.school_grade,
    data?.school_section,
    item?.phonecode?.name + item?.phone,
    item?.address
  ])

  const parentData = parents.map((item) => [
    item?.parent?.fullname,
    item?.parent?.email,
    item?.parent?.document_type?.name + item.parent.document,
    item?.parent?.phonecode?.name + item?.parent?.phone,
    item?.relationship?.name,
    item?.parent?.address
  ])



  autoTable(doc, {
    head: [['Nombre', 'Correo', 'DNI/C.I', 'Grado', 'Sección', 'Teléfono', 'Dirección']],
    body: userData,
    startY: 30,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [200, 200, 200] },
  });

  autoTable(doc, {
    head: [['Nombre del representante', 'Correo', 'DNI/C.I', 'Teléfono', 'Parentesco', 'Dirección']],
    body: parentData,
    startY: 60,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [200, 200, 200] },
  });

  doc.save('reporte-estudiantes.pdf');
};

export const generateAttendancePDF = (user, data) => {
  const doc = new jsPDF({
    orientation: 'landscape',
  });

  doc.text(`Año escolar: ${data.school_year}`, 14, 10);
  doc.text(`Lapso: ${data.school_lapse}`, 14, 20);


  const userData = user.map((item) => [
    item?.fullName,
    data?.school_grade,
    data?.school_section,
    item?.schoolDays,
    item?.assistDays,
    item?.inassistDays,
  ])

  autoTable(doc, {
    head: [['Nombre', 'Grado', 'Sección', 'Total dias escolares', 'Días de asistencia', 'Días de inasistencia']],
    body: userData,
    startY: 30,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [200, 200, 200] },
  });

  doc.save('reporte-asistencia.pdf');

};

export const generateQualificationsPDF = (student, data) => {
  const doc = new jsPDF({ orientation: 'landscape' });


  doc.setFontSize(12);
  doc.text(`Año escolar: ${data.school_year}`, 14, 10);
  doc.text(`Estudiante: ${student[0].fullname}`, 14, 17);
  doc.text(`Grado: ${data.school_grade}  Sección: ${data.school_section}`, 14, 24);
  doc.text(`Lapso: ${data.school_lapse}`, 14, 31);

  let y = 50;

  data.subjects.forEach((subject, index) => {
    // Encabezado de la materia
    doc.setFontSize(12);
    doc.text(`Materia: ${subject.subject_name}`, 14, y);
    y += 8;
    doc.text(`Calificación promedio: ${subject.total_pond_avg}`, 14, y);
    y += 8;
    doc.text(`Nota acumulada: ${ subject.total_pond } / ${ data?.maxQuantitativeScale }`, 14, y);
    y += 8;
    if (subject.total_pond_desc) {
      doc.text(`Descripción: ${subject.total_pond_desc || ''}`, 14, y);
      y += 8;
    }
    doc.text(`Porcentaje evaluado: ${parseFloat(subject.evaluated).toFixed(2)}%`, 14, y);
    y += 6;

    const questionsTable = subject.questions.map((q) => [
      q.name,
      q.type,
      `${q.percentage}%`,
      q.score_text ?? '-',
      q.total_pond ?? '-',
    ]);

    autoTable(doc, {
      head: [['Nombre', 'Tipo', 'Porcentaje', 'Nota', 'Nota ponderada']],
      body: questionsTable,
      startY: y,
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [220, 220, 220] },
      margin: { left: 14, right: 14 },
    });

    y = doc.lastAutoTable.finalY + 10; // actualizar posición Y para la siguiente materia
  });

  doc.save(`${student[0].fullname}-calificaciones.pdf`);
};

